import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Favorite, FavoriteResponse, Summary, SummaryResponse, WinRatioResponse } from "./types";

const backendURL = 'http://localhost:3001';

export const fetchCompanyAndFacilityCount = createAsyncThunk<SummaryResponse, { id: number | undefined, userToken: string | null }>(
  'user/fetchCompanyAndFacilityCount',
  async ({ id, userToken }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${backendURL}/api/user/getCompanyAndFacilityCount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, userToken })
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data: SummaryResponse = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

export const fetchFavoriteCount = createAsyncThunk<FavoriteResponse, { id: number | undefined, userToken: string | null }>(
  'user/fetchFavoriteCount',
  async ({ id, userToken }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${backendURL}/api/user/getFavoriteCount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, userToken })
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data: FavoriteResponse = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

export const fetchWinRatio = createAsyncThunk<WinRatioResponse, { id: number | undefined, userToken: string | null }>(
  'user/winRatio',
  async ({ id, userToken }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${backendURL}/api/user/getWinRatio`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, userToken })
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data: WinRatioResponse = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);